export const isExploreSectionEnabled = (value) => {
  if (value === true) return true;
  if (value == null || value === false) return false;
  return Number(value) === 1;
};
